import { createContext } from 'react'
import noop from 'lodash/noop'

const context = createContext({
  sections: [],
  registerSection: noop
})

const { Provider, Consumer } = context

export { Provider, Consumer }

export default context
